<div class="change-pwd-comp-container">
  <div class="change-pwd-form">
    <div class="header">
      <button
        pButton
        (click)="backButton()"
        class="back-button"
        severity="secondary"
        icon="ph ph-caret-left"
        aria-label="Back"></button>
      <span class="title-text">{{ 'doktar_app.auth.choose_password_title' | translate }}</span>
      <span class="subtitle-text">
        {{ 'doktar_app.auth.choose_password_description' | translate }}
      </span>
    </div>

    <span class="change-pwd-input-label">
      {{ 'doktar_app.common.password_label' | translate }}
    </span>

    <p-password
      class="password-input-container"
      [fluid]="true"
      inputStyleClass="password-input-text"
      name="password"
      [(ngModel)]="resetPwdModal.newPassword"
      [minlength]="1"
      [maxlength]="128"
      #passwordInput="ngModel"
      [placeholder]="'doktar_app.auth.register.create_password.password_placeholder' | translate"
      (onFocus)="passwordFocused = true"
      (onBlur)="passwordFocused = false"
      (ngModelChange)="onPasswordChange($event)"
      feedback="false"
      [toggleMask]="true">
      <ng-template pTemplate="showicon">
        <span class="p-component p-iconwrapper p-password-toggle-mask-icon p-password-mask-icon mask-icon">{{
          'Show'
        }}</span>
      </ng-template>
      <ng-template pTemplate="hideicon">
        <span class="p-component p-iconwrapper p-password-toggle-mask-icon p-password-mask-icon mask-icon">{{
          'Hide'
        }}</span>
      </ng-template>
    </p-password>
    <div class="password-info-container">
      @if (passwordFocused) {
        <span class="password-info-text">
          {{ 'doktar_app.auth.register.create_password.password_hint' | translate }}
        </span>
      }
      @if (resetPwdModal.newPassword && !passwordFocused && !isPasswordValid) {
        <span class="password-invalid-text">
          @for (error of passwordValidationErrors; track error) {
            {{ '• ' + error }}<br />
          }
        </span>
      }
    </div>

    <span class="confirm-pwd-input-label">
      {{ 'doktar_app.auth.register.create_password.repeat_password' | translate }}
    </span>
    <p-password
      class="password-input-container"
      [fluid]="true"
      inputStyleClass="confirm-password-input-text"
      [ngClass]="{
        'error-border': resetPwdModal.newPassword && confirmPassword && resetPwdModal.newPassword !== confirmPassword,
      }"
      name="confirmPassword"
      [(ngModel)]="confirmPassword"
      #confirmPasswordInput="ngModel"
      [placeholder]="'doktar_app.auth.register.create_password.repeat_password_placeholder' | translate"
      feedback="false"
      [toggleMask]="resetPwdModal.newPassword && isPasswordValid ? true : false"
      [disabled]="!isPasswordValid"
      visin>
      <ng-template pTemplate="showicon">
        <span class="p-component p-iconwrapper p-password-toggle-mask-icon p-password-mask-icon mask-icon">{{
          'Show'
        }}</span>
      </ng-template>
      <ng-template pTemplate="hideicon">
        <span class="p-component p-iconwrapper p-password-toggle-mask-icon p-password-mask-icon mask-icon">{{
          'Hide'
        }}</span>
      </ng-template>
    </p-password>

    <div class="change-pwd-buttons">
      <button
        pButton
        (click)="saveNewPassword()"
        class="continue-button"
        [label]="'doktar_app.common.save' | translate"
        [disabled]="
          !resetPwdModal.newPassword ||
          !confirmPassword ||
          passwordInput.invalid ||
          confirmPasswordInput.invalid ||
          resetPwdModal.newPassword !== confirmPassword ||
          !isPasswordValid
        "></button>
    </div>
  </div>
</div>
